export enum FontVariant {
  Default = "DEFAULT",
  BodyXSmall = "BODY_X_SMALL",
  BodySmall = "BODY_SMALL",
  BodyRegular = "BODY_REGULAR",
  BodyLarge = "BODY_LARGE",
  BodyXLarge = "BODY_X_LARGE",
  BodyXXLarge = "BODY_XX_LARGE",
  BulletPoints = "BULLET_POINTS",
  PullQuote = "PULL_QUOTE",
  HeaderH1 = "HEADER_H1",
  HeaderH2 = "HEADER_H2",
  HeaderH3 = "HEADER_H3",
  HeaderH4 = "HEADER_H4",
  HeaderH5 = "HEADER_H5",
  HeaderH6 = "HEADER_H6",
}

export enum ColorVariant {
  Default = "DEFAULT",
  Inherit = "INHERIT",
  Disabled = "DISABLED",
  Black = "BLACK",
  White = "WHITE",
  Primary = "BRAND_PRIMARY",
  Secondary = "BRAND_SECONDARY",
  Accent = "BRAND_ACCENT",
  BrandContrast = "BRAND_CONTRAST",
  Main = "STANDARD_MAIN",
  Dark = "STANDARD_DARK",
  Light = "STANDARD_LIGHT",
  StandardContrast = "STANDARD_CONTRAST",
  Success = "ALERT_SUCCESS",
  Warning = "ALERT_WARNING",
  Error = "ALERT_ERROR",
  Info = "ALERT_INFO",
  Custom1 = "CUSTOM_1",
  Custom2 = "CUSTOM_2",
  Custom3 = "CUSTOM_3",
  Custom4 = "CUSTOM_4",
}

export enum GradientVariant {
  Default = "DEFAULT",
  Gradient1 = "GRADIENT_1",
  Gradient2 = "GRADIENT_2",
  Gradient3 = "GRADIENT_3",
  Gradient4 = "GRADIENT_4",
}
